import React from 'react';
import { Group, Select, TextInput } from '@mantine/core';

import { STATUS_OPTIONS } from './priceSync.utils';

type PriceSyncQueueFiltersProps = {
    statusFilter: string;
    storeFilter: string;
    skuFilter: string;
    onStatusChange: (value: string) => void;
    onStoreChange: (value: string) => void;
    onSkuChange: (value: string) => void;
};

export function PriceSyncQueueFilters({
    statusFilter,
    storeFilter,
    skuFilter,
    onStatusChange,
    onStoreChange,
    onSkuChange,
}: PriceSyncQueueFiltersProps) {
    return (
        <Group gap="sm" wrap="wrap" mb="md">
            <Select
                placeholder="Status"
                data={STATUS_OPTIONS}
                value={statusFilter}
                onChange={v => onStatusChange(v ?? '')}
                clearable
                radius="lg"
                size="sm"
                w={160}
            />
            <TextInput
                placeholder="Store no."
                value={storeFilter}
                onChange={e => onStoreChange(e.currentTarget.value)}
                radius="lg"
                size="sm"
                w={140}
            />
            <TextInput
                placeholder="SKU"
                value={skuFilter}
                onChange={e => onSkuChange(e.currentTarget.value)}
                radius="lg"
                size="sm"
                w={160}
            />
        </Group>
    );
}
